<template>
  <div ref="dialog_layer" v-if="dialog_visible>0" tabindex="-1" :class="['grcdialog-layer']" 
        v-bind:style="{'left': layer_left, 'top': layer_top, 'min-width':layer_width+'px', 'min-height':layer_height+'px', 'width':'100%', 'height':'100%' }"
        @keydown="DialogKeydown"
  >
                    <div :class="['grcdialog-cont']" 
                    v-bind:style="{'width':cont_width+'px', 'height':cont_height+'px', 'top':dialog_top+'px', 'left':dialog_left+'px' }"
                    >
                        <div class="grcdialog-title" :class="['grcdialog-title', 
                        color=='white' ? 'grcdialog-title-white' : '',
                        color=='yellow' ? 'grcdialog-title-yellow' : '',
                        color=='grey' ? 'grcdialog-title-grey' : '',
                        color=='green' ? 'grcdialog-title-green' : '',
                        color=='red' ? 'grcdialog-title-red' : '',
                        color=='blue' ? 'grcdialog-title-blue' : '',
                         ]"  
                         v-html="title"
                         @mousedown="onTitleMouseDown"
                         >
                        </div>
                        <div class="grcdialog-text" style="height: calc(100% - 34px);">
                            <div style="width:100%; box-sizing:border-box;" v-show="formid==1">
                                <div style="width:100%; box-sizing:border-box; font-size:16px; line-height:22px; text-align:justify; margin-bottom:20px;" v-html="text1">
                                    
                                </div>

                                <div style="width:100%; box-sizing:border-box; text-align:center;">

                                    <GrcButton ref="btnModos" grc_text="Cookie-k személyreszabása" @grc-click="btnModos_click" grc_readonly="false" 
                                    grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="270px"
                                    grc_buttonpos="left"
                                    grc_textalign="center"
                                    grc_lefticon="<i class='fal fa-cog'></i>"
                                    style="display:inline-block; margin:10px;" />          

                                    <GrcButton ref="btnOsszes" grc_text="Összes cookie engedélyezése" @grc-click="btnOsszes_click" grc_readonly="false" 
                                    grc_color="green" grc_shadow="false" grc_radius="2px" grc_width="270px"
                                    grc_buttonpos="left"
                                    grc_textalign="center"
                                    grc_lefticon="<i class='fal fa-check'></i>"
                                    style="display:inline-block; margin:10px;" />          

                                </div>          


                            </div>

                            <div style="width:100%; box-sizing:border-box;" v-show="formid==2">
                                <div style="width:100%; box-sizing:border-box; font-size:16px; line-height:22px; text-align:justify; margin-bottom:20px;" v-html="text2">
                                    
                                </div>

                                <div v-for="(item, index)  in CookieList" v-bind:key="index" style="width:100%; box-sizing:border-box;">
                                    <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0" v-show="index==0">
                                        <tr>
                                        <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkCookieItem" /></td>
                                        <td valign="top" style="text-align:justify; font-family:'CmsDefault'; font-size:16px; line-height:22px; color:#222;" v-html="item.Nev">
                                        </td>
                                        </tr>
                                    </table>
                                </div>

                                <div style="width:100%; box-sizing:border-box; font-size:16px; line-height:22px; text-align:justify; margin:20px 0px;" v-html="text3">
                                    
                                </div>

                                <div style="width:100%; box-sizing:border-box; text-align:center;">

                                    <GrcButton ref="btnMentes" grc_text="Beállítások mentése" @grc-click="btnMentes_click" grc_readonly="false" 
                                    grc_color="green" grc_shadow="false" grc_radius="2px" grc_width="200px"
                                    grc_buttonpos="left"
                                    grc_textalign="center"
                                    grc_lefticon="<i class='fal fa-check'></i>"
                                    style="display:inline-block; margin:10px;" />          

                                </div>          


                            </div>

                            
                        </div>

                        <div class="grcdialog-button-cont" style="display:none;">
                          <GrcButton v-for="(btn, index) in buttons" ref="btn"
                          v-bind:grc_text=btn.text @grc-click="ButtonClick(index)" grc_readonly="false" 
                          v-bind:grc_color=btn.color grc_shadow="false" grc_radius="2px" 
                          v-bind:grc_width=btn.width
                          @grc-keydown="ButtonPress($event,index)"
                          v-bind:key="index"
                          style="margin-left:10px;" />                    

                        </div>
                    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'


export default {
  name: 'GrcDialog_CookieConsent',
  components:
  {
    GrcButton,
    GrcCheckboxMobile
  },
  props: {
  },
  data () {
    return {
        layer_left:0,
        layer_top:0,
        layer_width:300,
        layer_height:250,
        dialog_visible: 0,
        cont_width:0,
        cont_height:0,
        title:"",
        text:"",
        color:"",
        dialog_top:0,
        dialog_left:0,

        default_padding_top: 100,
        default_cont_width:300,
        default_cont_height: 250,
        
        buttons:[],
        button_focus_index:-1,

        move_mouse_startX:-1,
        move_mouse_startY:-1,
        move_dialog_startX:-1,
        move_dialog_startY:-1,

        formid:1,

        text1:"",
        text2:"",
        text3:"",

        CookieName:"",
        CookieContent:"",
        CookieList:[
            {id:"GA",Nev:"Google Analytics", Value:0}, 
            {id:"HJ",Nev:"Hotjar",Value:0},
            {id:"FBP",Nev:"Facebook Pixel", Value:0}, 
            {id:"TAB",Nev:"Talk-a-bot", Value:0}, 
            {id:"TEADS",Nev:"Teads", Value:0},
        ],

        PromiseResultObject: null
    }
  },
  watch : {
  },

  created: function()
  {
  },
  computed: {
  },
  updated: function() {

    this.$nextTick(function () {
      if (this.dialog_visible == 1)
      {
        this.dialog_visible = 2;

        this.button_focus_index = -1;
        for(var i=0;i<this.buttons.length;i++)
        {
          if (this.buttons[i].default == true) { this.button_focus_index = i; }
        }
        this.FocusButton();
      }
    });
  },

  mounted: function () {
    document.addEventListener('mousemove',  this.MouseMove);
    document.addEventListener('mouseup',  this.MouseUp);
  },

  destroyed: function()
  {
    document.removeEventListener('mousemove',  this.MouseMove);
    document.removeEventListener('mouseup',  this.MouseUp);
  },


  methods: {

    btnOsszes_click()
    {
        for(let i=0; i<this.CookieList.length; i++)
        {
            this.CookieList[i].Value = 1;
        }

        this.Mentes();

    },

    btnModos_click()
    {
        this.SetCookieList();
        this.formid = 2;

        /*
        if (grccomp_getScreenSize().width < 500) { this.ResizeDialog(320, 600); }
        else { this.ResizeDialog(500, 600); }
        */
    },

    btnMentes_click()
    {
        for(let i=0; i<this.CookieList.length; i++)
        {
            this.CookieList[i].Value = this.$refs.chkCookieItem[i].GetValue();
        }
        
        this.Mentes();
    },

    Mentes()
    {
        let res = "";
        for(let i=0; i<this.CookieList.length; i++)
        {
            if (this.CookieList[i].Value ==1) { res = res + this.CookieList[i].id+","; }
        }
        this.$cookie.set(this.CookieName, res, 365);

        this.CloseDropdown();
    },

    SetCookieList()
    {
        this.CookieContent = this.$cookie.get(this.CookieName);
        if (this.CookieContent == null) 
        { 
            this.CookieContent = "";  
            for(let i=0; i<this.CookieList.length; i++)
            {
                this.$refs.chkCookieItem[i].SetValue(1);
            }
        }
        else
        {
            this.CookieContent = ","+this.CookieContent;
            for(let i=0; i<this.CookieList.length; i++)
            {
                if (this.CookieContent.includes(","+this.CookieList[i].id+","))
                {
                    this.$refs.chkCookieItem[i].SetValue(1);
                }
                else
                {
                    this.$refs.chkCookieItem[i].SetValue(0);
                }
            }
        }

    },

    onTitleMouseDown(e)
    {
      this.move_mouse_startX = e.pageX;
      this.move_mouse_startY = e.pageY;
      this.move_dialog_startX = this.dialog_left;
      this.move_dialog_startY = this.dialog_top;
    },

    MouseMove(e)
    {
      if (this.move_mouse_startX < 0) { return; }

      this.dialog_left = this.move_dialog_startX + (e.pageX - this.move_mouse_startX);
      this.dialog_top = this.move_dialog_startY + (e.pageY - this.move_mouse_startY);
    },

    MouseUp(e)
    {
      this.move_mouse_startX = -1;
    },

    ResizeDialog(pWidth, pHeight)
    {
        var width = pWidth;
        var height = pHeight;
        var padding_top = -1;

        var isCentered = false;

        if (padding_top == -1) { isCentered = true; }

        var bs = grccomp_getScreenSize();

        if (width > bs.width) { width = bs.width - 10; }
        if (height > bs.height-50) { height = bs.height - 10-50; }
        
        var left = (bs.width - width) / 2;
        var top = (bs.height - height) / 2;
        if (isCentered == false) 
        { 
          top = padding_top; 
        }
        else
        {
          if (top > 0) { top = top/2; }
        }


        this.cont_width = width;
        this.cont_height = height;
        this.dialog_top = top;
        this.dialog_left = left;

    },


    ShowDialog(pParams, pCookieName)
    {
        this.formid=1;
        this.CookieName = pCookieName;

        this.text1 = grcmain_GetTextBookItem("CookieConsent", "text1");
        this.text2 = grcmain_GetTextBookItem("CookieConsent", "text2");
        this.text3 = grcmain_GetTextBookItem("CookieConsent", "text3");


        this.$emit("popupopened");

        grcmain_SetBodyScrollable(false);

        var title = grcmain_GetTextBookItem("CookieConsent", "title"); // pParams.title;
        var text = pParams.text;
        var color = pParams.color;
        var width = pParams.width;
        var height = pParams.height;
        var padding_top = pParams.padding_top;

        var isCentered = false;
        

        if (title == undefined) { title = ""; }
        if (text == undefined) { text = ""; }
        if (color == undefined) { color = "white"; }
        if (width == undefined) { width = this.default_cont_width; }
        if (height == undefined) { height = this.default_cont_height; }
        if (padding_top == undefined) { isCentered = true; }
        if (padding_top == -1) { isCentered = true; }

        for(var i=0; i<pParams.buttons.length; i++)
        {
            pParams.buttons[i].ref = "btn"+i;
        }

        this.buttons = pParams.buttons;

        //var bs = grccomp_getBodySize();
        var bs = grccomp_getScreenSize();

        this.layer_width = bs.width;
        this.layer_height = bs.height;

        if (width > bs.width) { width = bs.width - 10; }
        if (height > bs.height-50) { height = bs.height - 10-50; }
        
        //console.log(bs.height);
        //console.log(height);

        var left = (bs.width - width) / 2;
        var top = (bs.height - height) / 2;
        if (isCentered == false) 
        { 
          top = padding_top; 
        }
        else
        {
          if (top > 0) { top = top/2; }
        }


        this.title = title;
        this.text = text;
        this.color = color;
        this.cont_width = width;
        this.cont_height = height;
        this.dialog_top = top;
        this.dialog_left = left;


        
        this.dialog_visible = 1;

        return new Promise((resolve, reject) => {
          this.PromiseResultObject = resolve;
        });
    },

    Alert(pTitle, pText)
    {
      var params = grccomp_dialog_alert_GetDefaults(pTitle, pText);
      return this.ShowDialog(params);
    },

    Confirm(pTitle, pText)
    {
      var params = grccomp_dialog_yesno_GetDefaults(pTitle, pText);
      return this.ShowDialog(params);
    },



    DialogKeydown(e)
    {
      e.preventDefault();
      e.stopPropagation();
    },

    ButtonClick(pButtonIndex)
    {
        grcmain_SetBodyScrollable(true);
        this.$emit("popupclosed");
        this.dialog_visible = -1;
        var res = this.buttons[pButtonIndex].value;

        this.PromiseResultObject(res);
    },

    CloseDropdown()
    {
        grcmain_SetBodyScrollable(true);
        this.$emit("popupclosed");
        this.dialog_visible = -1;
        var res = "ESC";
        this.PromiseResultObject(res);
    },

    ButtonPress(pKeyCode, pIndex)
    {
      if (pKeyCode == 39)
      {
          if (this.button_focus_index >= 0)
          {
            var i = this.button_focus_index + 1;
            if (i>this.buttons.length-1) { i = 0; }
            this.button_focus_index = i;
            this.FocusButton();
          }

          return;
      }

      if (pKeyCode == 37)
      {
          if (this.button_focus_index >= 0)
          {
            var i = this.button_focus_index - 1;
            if (i<0) { i = this.buttons.length-1; }
            this.button_focus_index = i;
            this.FocusButton();
          }

          return;
      }

      if (pKeyCode == 27)
      {
        grcmain_SetBodyScrollable(true);
        this.$emit("popupclosed");
        this.dialog_visible = -1;
        var res = "ESC";

        this.PromiseResultObject(res);
        return;
      }


      //console.log(pKeyCode+" "+pIndex);
    },

    FocusButton()
    {
        if (this.button_focus_index >= 0)
        {
          this.$refs.btn[this.button_focus_index].SetFocus();
        }
        else
        {
          this.$refs.dialog_layer.focus();        
        }
    }

    
    
  }  // end: methods



}
</script>

